<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/parts/_form.vue';
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
  mixins: [StoreForm],
  components: {App, Form},
  data() {
    return {
      formRoute: route('api.v1.parts.store'),
      redirectRoute: route('parts.index'),
      stayOnPageRedirect: route('parts.edit', {part: '_id_'}),
    }
  },
}
</script>

<template>
  <App title="Onderdeel toevoegen">
    <form id="partForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          form-id="partForm"
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>